"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSliceHelper = createSliceHelper;
exports.testPort = void 0;
var PATH_SEPARATOR = '/';
var SUFFIX_SEPARATOR = '__';

function createSliceHelper(parentSliceHelper, sliceName, initialSlice) {
  if (!sliceName || sliceName.indexOf(PATH_SEPARATOR) !== -1 || sliceName.indexOf(SUFFIX_SEPARATOR) !== -1) {
    throw new Error("invalid sliceName: ".concat(sliceName));
  }

  var slicePath = parentSliceHelper ? "".concat(parentSliceHelper.slicePath).concat(PATH_SEPARATOR).concat(sliceName) : sliceName;
  var suffix = slicePath.split(PATH_SEPARATOR).reverse().join(SUFFIX_SEPARATOR);

  var sliceSelector = function sliceSelector(state) {
    var parentSlice = parentSliceHelper ? parentSliceHelper.sliceSelector(state) : state;
    var slice = parentSlice ? parentSlice[sliceName] : undefined;

    if (slice === undefined) {
      return initialSlice;
    }

    return slice;
  };

  var suffixKey = function suffixKey(key) {
    return "".concat(key).concat(SUFFIX_SEPARATOR).concat(suffix);
  };

  return {
    sliceName: sliceName,
    slicePath: slicePath,
    sliceSelector: sliceSelector,
    suffixKey: suffixKey
  };
}

var testPort = {
  PATH_SEPARATOR: PATH_SEPARATOR,
  SUFFIX_SEPARATOR: SUFFIX_SEPARATOR
};
exports.testPort = testPort;